'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isErrorWithLogs = error => error instanceof Error && 'logs' in error;

exports.isErrorWithLogs = isErrorWithLogs;
//# sourceMappingURL=Program.cjs.map
